import createVueApp from '@phoenix/createVueApp';
import EngravingTool from '@maison/components/engravingTool/EngravingTool.vue';

const app = createVueApp({}, true);
app.component('EngravingTool', EngravingTool);
app.mount('#phoenix-engraving-tool');
